'use client';
import { useState, type ReactNode } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from '@/components/ui/sonner';
import { createQueryClient } from '@/lib/query/client';

/**
 * Root-level providers. Note that `CommandPaletteHost` lives in each
 * route-group layout (Phase 2H Stage E Task 28) — not here — so each
 * layout can pick the correct search backend (`mode='staff' | 'merchant'`)
 * and so auth / public pages don't pay the cost of the keyboard listener.
 */
export function Providers({ children }: { children: ReactNode }) {
  const [client] = useState(() => createQueryClient());
  return (
    <QueryClientProvider client={client}>
      {children}
      <Toaster richColors position="bottom-right" />
    </QueryClientProvider>
  );
}
